import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { MyPage } from './MyPage/MyPage';
import { Blog } from './Blog/Blog';
import { Projects } from './Projects/Projects';
import { Sentence } from "./Sentence";
import { Content } from "./Content";
import { AdminSlider } from "./AdminSlider/AdminSlider";
import { CustomImages } from "./CustomImages/CustomImages";
import { Files } from "./Files/Files";

export function renderAdminMyPage() {
    ReactDOM.render(<MyPage></MyPage>,
        document.getElementById('react-app')
    );
}

export function renderAdminBlog() {
    ReactDOM.render(<Blog></Blog>,
        document.getElementById('react-app')
    );
}

export function renderAdminSlider() {
    ReactDOM.render(<AdminSlider></AdminSlider>,
        document.getElementById('react-app')
    );
}

export function renderAdminProjects() {
    ReactDOM.render(<Projects></Projects>,
        document.getElementById('react-app')
    );
}

export function renderFiles() {
    ReactDOM.render(<Files></Files>,
        document.getElementById('react-app')
    );
}

export function renderCustomImages() {
    ReactDOM.render(<CustomImages></CustomImages>,
        document.getElementById('react-app')
    );
}

export function renderSentence(elementId: string, sentenceId: number, initialText: string, languageId: number) {
    ReactDOM.render(<Sentence sentenceId={sentenceId} initialText={initialText} languageId={languageId}></Sentence>,
        document.getElementById(elementId)
    );
}

export function renderContent(elementId: string, contentId: number, initialText: string, languageId: number) {
    ReactDOM.render(<Content contentId={contentId} initialText={initialText} languageId={languageId}></Content>,
        document.getElementById(elementId)
    );
}


// WEBPACK FOOTER //
// ./ClientApp/boot.tsx